import { useSelector } from 'react-redux';
import { Outlet, Navigate } from 'react-router-dom';
import { store } from '../index';
import * as actions from '../store/actions/GlobalActions';

function RestrictedRoute({ roles }) {
  const userRole = useSelector((state) => state.GlobalReducer.loggedUser?.role);
  const adminRole = useSelector((state) => state.GlobalReducer.loggedUser?.adminRole);
  const roleMatches = roles.includes(userRole) || roles.includes(adminRole);

  if (roleMatches) return <Outlet />;

  store.dispatch({
    type: actions.SHOW_ERROR_TOAST,
    msg: 'Operation failed - Access Forbidden',
  });

  return <Navigate to={'/'} />
}

export default RestrictedRoute;